export const stopAllPlayingAudio = new Event("stopAllPlayingAudio");
export const themeChange = new Event("themeChange");
